import React from 'react';
import moment from 'moment';

import {
    Table,
    Card
} from 'antd';

import {
    _getStockIntegrations
} from '../../services'

import { ADMIN_URL } from '../../index'

class StockIntegrationTable extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            stockIntegrations: [],
            stockIntegrationsCount: 0,

            page: 1,
            limit: 50
        }
    }


    render() {
        return (
            <Card title='Stock Integrations'>
                {this.renderTable()}
            </Card>
        )
    }

    componentDidMount() {
        this.getData()
    }
    
    getData = () => {

        const { page, limit } = this.state

        _getStockIntegrations({ page, limit })
        .then(data => {
            this.setState({
                stockIntegrations: data.data.docs,
                stockIntegrationsCount: data.data.count,
            })
        })
    }

    renderTable = () => {
        
        const { stockIntegrations, stockIntegrationsCount, page, limit} = this.state

        const columns = [{
            title: 'Date Created',
            dataIndex: 'dateCreated',
            render: (dateCreated) => moment(dateCreated).format('LL')
        },{
            title: 'SupplierId',
            dataIndex: 'supplierId'
        },{
            title: 'IntegrationType',
            dataIndex: 'integrationType'
        },{
            title: 'Actions',
            render: (actions, record) => <a href={`${ADMIN_URL}/tech/stock-integration/${record.supplierId}`}>View</a>
        }]

        return <Table
            dataSource={stockIntegrations}
            columns={columns}
            pagination={{
                current: page,
                pageSize: limit,
                total: stockIntegrationsCount,
                onChange: this.onTablePageChange
            }}

        />
    }

    onTablePageChange = (page) => {
        this.setState({
            page: page
        }, this.getData)
    }

}

export default StockIntegrationTable


// WEBPACK FOOTER //
// ./src/components/stock-integration/table.js